import { Box } from '@mantine/core';

import { useGetColor } from 'hooks';

import type { IconPropsType } from './types';

export const UserGroupIcon = ({
  color,
  size = 24,
  sx,
  ...props
}: IconPropsType) => {
  const iconColor = useGetColor(color);

  return (
    <Box
      component="svg"
      sx={sx}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15.291 5.82861C17.0834 5.82861 18.5368 7.28144 18.5371 9.07373C18.5371 10.0153 18.1326 10.8598 17.4922 11.4526C18.9666 12.172 20 13.5952 20 15.2915C20 15.6701 19.693 15.9769 19.3145 15.9771C18.9359 15.9769 18.6289 15.6701 18.6289 15.2915C18.6289 13.7599 17.2855 12.4068 15.4688 12.3237L15.291 12.3198L15.0732 12.311C14.8978 12.8285 14.5935 13.2848 14.2012 13.6479C15.675 14.3675 16.708 15.79 16.708 17.4858C16.7079 17.8645 16.4011 18.1714 16.0225 18.1714C15.644 18.1712 15.337 17.8644 15.3369 17.4858C15.3369 15.905 13.9058 14.5144 12 14.5142C10.094 14.5142 8.66309 15.9048 8.66309 17.4858C8.66302 17.8644 8.35603 18.1712 7.97754 18.1714C7.59887 18.1714 7.29108 17.8645 7.29102 17.4858C7.29102 15.79 8.32414 14.3665 9.79785 13.647C9.40584 13.2839 9.10114 12.8282 8.92578 12.311C8.85384 12.3158 8.78104 12.3198 8.70801 12.3198L8.53125 12.3237C6.71439 12.4067 5.3711 13.7598 5.37109 15.2915C5.37105 15.6702 5.06423 15.9771 4.68555 15.9771C4.30694 15.977 4.00004 15.6701 4 15.2915C4 13.5959 5.03258 12.1733 6.50586 11.4536C5.86571 10.8608 5.46289 10.015 5.46289 9.07373C5.46321 7.28163 6.9159 5.82891 8.70801 5.82861C10.1351 5.82861 11.3433 6.75063 11.7783 8.03076C11.8515 8.02582 11.9256 8.02295 12 8.02295C12.0742 8.02295 12.1478 8.02586 12.2207 8.03076C12.6556 6.75063 13.864 5.82879 15.291 5.82861ZM12 9.39404C10.9651 9.39414 10.1263 10.2332 10.126 11.2681C10.126 12.3031 10.9649 13.142 12 13.1421C13.0351 13.142 13.874 12.3031 13.874 11.2681C13.8737 10.2332 13.0349 9.39415 12 9.39404ZM8.70801 7.19971C7.67331 7.2 6.83431 8.03904 6.83398 9.07373C6.83398 10.1087 7.67312 10.9484 8.70801 10.9487C8.72883 10.9487 8.74987 10.9465 8.77051 10.9458C8.87896 9.84752 9.53423 8.90959 10.4609 8.40967C10.1927 7.70293 9.50885 7.19971 8.70801 7.19971ZM15.291 7.19971C14.4903 7.19988 13.8062 7.70292 13.5381 8.40967C14.465 8.90951 15.12 9.84732 15.2285 10.9458C15.2493 10.9465 15.2701 10.9487 15.291 10.9487C16.3262 10.9487 17.165 10.1089 17.165 9.07373C17.1647 8.03886 16.326 7.19971 15.291 7.19971Z"
        fill={iconColor}
      />
    </Box>
  );
};
